import StarRating from './StarRating.jsx';

export default StarRating;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/StarRating/index.js